import { useContext, useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useExtensions } from "../hooks/useExtensions";
import { AppContext } from "../context/index";
import { I18N_CHANGE_LANGUAGE } from "../constants";
import i18n from "../i18n";

export const ProtectedRoutes = (): any => {
  useEffect(() => {
    window.addEventListener(I18N_CHANGE_LANGUAGE, (({
      detail,
    }: CustomEvent) => {
      i18n.changeLanguage(detail);
    }) as EventListener);
  }, []);
  // Block to manage the filters in the texts and messages page
  const location = useLocation();

  const {
    appState: { user },
    setAppState,
  } = useContext(AppContext);

  const { prevLocation, currentLocation } = useExtensions(location.pathname);

  useEffect(() => {
    setAppState((prev)=>({
      ...prev,
      activateAlert: !prev.activateAlert
    }));
    if ((
      prevLocation &&
      currentLocation &&
      !(prevLocation?.includes(currentLocation) ||
        currentLocation?.includes(prevLocation))
    ) || (prevLocation === "/") || (currentLocation === "/")) {
      setAppState((prev) => ({
        ...prev,
        pageFilter: null,
        functionalityCode: 
          ((!!prevLocation && prevLocation?.split('/')?.length < 4) &&
          (!!currentLocation && currentLocation?.split('/')?.length < 4) &&
          currentLocation !== '/pointsofattention')
          ? (currentLocation ?? '')
          : prev.functionalityCode,
      }));
    };
    (!currentLocation?.includes('/translations/import')) && sessionStorage.removeItem('import-filters-table');
    (!currentLocation?.includes('/applications/edit/import')) && sessionStorage.removeItem('import-config-filters-table');
  }, [prevLocation, currentLocation, setAppState]);

  if (!user) {
    return <Navigate to="/login" />;
  }

  return <Outlet />;
};
